import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createPackage,
  getPackage,
  getPackages,
  editPackage,
  deletePackage,
} from "api/packageApi";

export const PACKAGE_QUERY_KEY = "packages";

export const usePackages = (params = {}, enabled=true) => {
  return useQuery({
    queryKey: [PACKAGE_QUERY_KEY, params],
    queryFn: () => getPackages(params),
    keepPreviousData: true,
    enabled
  });
};

export const usePackage = (id) => {
  return useQuery({
    queryKey: [PACKAGE_QUERY_KEY, id],
    queryFn: () => getPackage(id),
    enabled: !!id,
  });
};

export const useCreatePackage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPackage,
    onSuccess: (data) => {
      if (data?.success) queryClient.invalidateQueries([PACKAGE_QUERY_KEY]);
    },
  });
};

export const useEditPackage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: editPackage,
    onSuccess: (data) => {
      if (data?.success) queryClient.invalidateQueries([PACKAGE_QUERY_KEY]);
    },
  });
};

export const useDeletePackage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deletePackage,
    onSuccess: (data) => {
      if (data?.success) queryClient.invalidateQueries([PACKAGE_QUERY_KEY]);
    },
  });
};
